"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HbtFileExtensionType = void 0;
var HbtFileExtensionType;
(function (HbtFileExtensionType) {
    HbtFileExtensionType["JPEG"] = "jpeg";
    HbtFileExtensionType["JPG"] = "jpg";
    HbtFileExtensionType["PDF"] = "pdf";
    HbtFileExtensionType["PNG"] = "png";
    // word
    HbtFileExtensionType["DOC"] = "doc";
    HbtFileExtensionType["DOCX"] = "docx";
    // Excel
    HbtFileExtensionType["CSV"] = "csv";
    HbtFileExtensionType["XLS"] = "xls";
    HbtFileExtensionType["XLSM"] = "xlsm";
    HbtFileExtensionType["XLSX"] = "xlsx";
    HbtFileExtensionType["XLSB"] = "xlsb";
    HbtFileExtensionType["XLTX"] = "xltx";
    HbtFileExtensionType["XLTM"] = "xltm";
    HbtFileExtensionType["XLT"] = "xlt";
    HbtFileExtensionType["XML"] = "xml";
    HbtFileExtensionType["XLAM"] = "xlam";
    HbtFileExtensionType["XLA"] = "xla";
    HbtFileExtensionType["XLW"] = "xlw";
    HbtFileExtensionType["XLR"] = "xlr";
    // Text
    HbtFileExtensionType["TXT"] = "txt";
})(HbtFileExtensionType = exports.HbtFileExtensionType || (exports.HbtFileExtensionType = {}));
